import { isNil, isEmpty } from 'ramda';
var ageErrors = {
  domestic: 'Your domestic worker needs to be between 18 and 64 years old to qualify.',
  family: 'You need to be between 18 and 64 years old to qualify.',
  group: 'Your employees need to be between 18 and 64 years old to qualify.'
};
export var validateAge = function validateAge(age, type) {
  if (isEmpty(age) || isNil(age)) {
    return {
      isValid: true
    };
  }

  if (age >= 18 && age <= 64) {
    return {
      isValid: true
    };
  }

  return {
    isValid: false,
    error: ageErrors[type]
  };
};
var citizenshipErrors = {
  domestic: 'Your domestic worker needs to be\nSouth African or a legal foreigner.',
  family: 'You need to have a valid South African ID number.'
};
export var validateCitizenship = function validateCitizenship(citizenship, type) {
  if (citizenship === 'neither' || citizenship === 'do not') {
    return {
      isValid: false,
      error: citizenshipErrors[type]
    };
  }

  return {
    isValid: true
  };
};
var fulltimeError = 'Your domestic worker needs to have worked 3 days or more per month for you, for the last 6 months.';
export var validateFulltime = function validateFulltime(isFulltime, type) {
  if (isFulltime === 'No') {
    return {
      isValid: false,
      error: fulltimeError
    };
  }

  return {
    isValid: true
  };
};
export var findErrors = function findErrors(valid, validationFields, type) {
  var age = validationFields.age,
      citizenship = validationFields.citizenship,
      is_fulltime = validationFields.is_fulltime;

  if (valid === false) {
    var ageValidation = validateAge(age, type);
    var citizenshipValidation = validateCitizenship(citizenship, type);
    var isFulltimeValidation = validateFulltime(is_fulltime, type);
    var validations = [ageValidation, citizenshipValidation, isFulltimeValidation];
    var invalids = validations.filter(function (v) {
      return v.isValid === false;
    });
    var errors = invalids.map(function (invalid) {
      return invalid.error;
    });
    return errors.join('\n');
  }

  return '';
};